<section class="electron-deprecation-warning" *ngIf="isElectron" role="status">
  <div class="electron-deprecation-warning__content">
    <h3>{{ 'documents.electronDeprecation.title' | translate }}</h3>
    <p>{{ 'documents.electronDeprecation.description' | translate }}</p>
    <div class="electron-deprecation-warning__actions">
      <a class="btn-S btn-filled" [href]="webDocumentsUrl" target="_blank" rel="noopener noreferrer">
        {{ 'documents.electronDeprecation.webAction' | translate }}
      </a>
      <a class="btn-S btn-text" [href]="hsmBridgeDownloadUrl" target="_blank" rel="noopener noreferrer">
        {{ 'documents.electronDeprecation.hsmBridgeAction' | translate }}
      </a>
    </div>
  </div>
</section>
